import React from 'react';
import glamorous from 'glamorous';

import ImgWithSource from '../img-with-source';
import zipCompImg from '../../../../assets/images/docs/zip-compression/zip-compression-2.png';
import { MENU_ENTRIES } from '../constants';

const ZipCompression = () => {
  return (
    <div data-subsection={MENU_ENTRIES.creatingZipFileZipCompression}>
      <h4>
        Compressing your files
      </h4>
      <p>
        Compress the folder with the recalls into one single zip file by right-clicking on the name of the folder,
        selecting the <strong>Send to</strong> option and then the <strong>Compressed (zipped) folder</strong> option on
        your computer.
      </p>
      <div>
        <ImgWithSource src={zipCompImg}/>
        <br/>
        <p>
          You are now ready to upload the ZIP file into the portal.
        </p>
      </div>
      <br/>
      <p className="pt-callout pt-icon-info-sign">
        <strong>Note:</strong> The method for creating a zip file may vary across operating systems. Check with your
        technical team which process to follow under your system.
      </p>
    </div>
  );
};

export default ZipCompression;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/creating-zip-file/zip-compression.js